import { __extends } from "tslib";
import { fetchDocuments } from '@gn-audio/core/api/knowledge-base';
import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
import { ContactSupportSectionController } from 'src/Feature/ContactSupport/app';
import { makeUrlDomainIndependent } from 'src/Foundation/Design/app';
var DocumentType = (function () {
    function DocumentType(documentType) {
        if (documentType === void 0) { documentType = {}; }
        this.title = documentType.title;
        this.type = documentType.type;
        this.items = documentType.items;
        this.selectedItem = documentType.selectedItem;
    }
    return DocumentType;
}());
var DocumentsSpotController = (function (_super) {
    __extends(DocumentsSpotController, _super);
    function DocumentsSpotController($scope, $q, siteLanguage, productContextService, dynamicPagesSpotsDisplayOptionsService, $rootScope) {
        var _this = _super.call(this, $scope, productContextService, dynamicPagesSpotsDisplayOptionsService, GroupRestrictedSpotType.Other) || this;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.siteLanguage = siteLanguage;
        _this.$rootScope = $rootScope;
        _this.initialize();
        _this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                _this.$scope.documents = [];
                return;
            }
            _this.$scope.group = group;
            _this.setSupportPageUrl();
            _this.$scope.promise = _this.$q.when(fetchDocuments(group.groupId)
                .then(function (documents) {
                _this.$scope.documents = documents || [];
                _this.processDocuments();
            }));
        });
        _this.$rootScope.$on('sectionToggler:toggle', function (event, data) {
            if (data.sectionName === 'documents') {
                _this.$scope.collapsed = data.collapsed;
            }
        });
        var selectedDocumentTypesJsonWatcher = _this.$scope.$watch('selectedDocumentTypesJson', function () {
            var documentTypes;
            if (!_this.$scope.selectedDocumentTypesJson || _this.$scope.selectedDocumentTypesJson.trim() === 'null') {
                return;
            }
            documentTypes = JSON.parse(_this.$scope.selectedDocumentTypesJson);
            Array.prototype.push.apply(_this.$scope.selectedDocumentTypes, documentTypes.map(function (d) { return new DocumentType(d); }));
            selectedDocumentTypesJsonWatcher();
        });
        return _this;
    }
    DocumentsSpotController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    DocumentsSpotController.prototype.initialize = function () {
        this.$scope.collapsed = true;
        this.$scope.documents = [];
        this.$scope.documentTypes = [];
        this.$scope.selectedDocumentTypes = [];
        this.$scope.getStartedDocuments = [];
    };
    DocumentsSpotController.prototype.processDocuments = function () {
        var _this = this;
        this.$scope.documents
            .forEach(function (d) { d.fileUrl = makeUrlDomainIndependent(d.fileUrl); });
        this.$scope.documentTypes = (this.$scope.documents || [])
            .map(function (documentItem) { return documentItem.documentType; })
            .filter(function (documentType) { return Boolean(documentType); })
            .filter(function (documentType, index, context) {
            return context.indexOf(documentType) === index;
        })
            .map(function (documentType) {
            var items = _this.$scope.documents
                .filter(function (documentItem) { return (documentItem.documentType === documentType); })
                .sort(function (documentItem1, documentItem2) {
                if (documentItem1.languageTitle > documentItem2.languageTitle) {
                    return 1;
                }
                if (documentItem1.languageTitle < documentItem1.languageTitle) {
                    return -1;
                }
                return 0;
            });
            var selectedItem = _this.findDocumentByLanguageCode(items, _this.siteLanguage) ||
                _this.findDocumentByMarketLocale(items, _this.siteLanguage) ||
                _this.findDocumentByMarketLocale(items, "en-us") ||
                items[0];
            return {
                items: items,
                selectedItem: selectedItem,
                title: selectedItem.documentTypeTranslation,
                type: documentType,
            };
        });
        this.$scope.getStartedDocuments = this.$scope.documentTypes.filter(function (type) { return _this.$scope.selectedDocumentTypes.find(function (_a) {
            var title = _a.title;
            return type.title === title;
        }); });
        this.$scope.showDocumentsOnGetStartedPages = this.$scope.getStartedDocuments.length > 0;
    };
    DocumentsSpotController.prototype.findDocumentByLanguageCode = function (items, languageCode) {
        if (languageCode === void 0) { languageCode = ''; }
        return items
            .filter(function (d) {
            return (d.languageCode || '').toLowerCase() === languageCode.toLowerCase();
        })[0];
    };
    DocumentsSpotController.prototype.findDocumentByMarketLocale = function (items, marketLocale) {
        if (marketLocale === void 0) { marketLocale = ''; }
        return items
            .filter(function (d) {
            return (d.marketLocales || []).some(function (m) { return marketLocale.toLowerCase() === m.toLowerCase(); });
        })[0];
    };
    DocumentsSpotController.prototype.setSupportPageUrl = function () {
        if (!this.$scope.group) {
            return;
        }
        this.$scope.supportPageUrl = this.$scope.group.supportPageUrl + "#/TECH#" + this.$scope.group.sku;
    };
    DocumentsSpotController.$inject = [
        '$scope',
        '$q',
        'siteLanguage',
        'productContextService',
        'dynamicPagesSpotsDisplayOptionsService',
        '$rootScope',
    ];
    return DocumentsSpotController;
}(ContactSupportSectionController));
export { DocumentsSpotController };
